"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import dispatcher from "./../dispatcher";
import Toast from "vwa/components/Toast";

export default async function clearPOICollaboration(poiId, collaboratorId) {
	try {
		const response = await api.delete("pois/collaborations", {
			_id:				poiId,
			collaborators:		[collaboratorId]
		});
		dispatcher.dispatch("removeCollaboration", poiId, response.collaborations[0].collaborator);
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}


// WEBPACK FOOTER //
// ./src/api/clearPOICollaboration.js